import { CartLinesUpdateEvent } from '@shopify/events';

/**
 * MotoRava bundle: adds the product and its bundle partner to the cart in one
 * request, using the same CartLinesUpdateEvent flow as the product form so the
 * cart drawer, cart count and cart items refresh the normal way.
 */
class MrBundle extends HTMLElement {
  /** @type {AbortController | undefined} */
  #abort;

  connectedCallback() {
    this.#abort?.abort();
    this.#abort = new AbortController();
    this.querySelector('[ref="button"]')?.addEventListener('click', this.#onClick, { signal: this.#abort.signal });
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  #onClick = async () => {
    const button = this.querySelector('[ref="button"]');
    const note = this.querySelector('.mr-bundle__note');
    const ids = (this.dataset.items || '').split(',').filter(Boolean);
    if (!(button instanceof HTMLButtonElement) || ids.length === 0) return;

    button.setAttribute('aria-busy', 'true');
    const items = ids.map((id) => ({ id: Number(id), quantity: 1 }));
    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => (el instanceof HTMLElement ? el.dataset.sectionId : ''))
      .filter(Boolean);

    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: items.map((item) => ({ merchandiseId: String(item.id), quantity: 1 })),
        promise: deferred.promise,
      })
    );

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: sectionIds.join(',') }),
      });
      const data = await response.json();
      const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
      const didError = Boolean(data.status);

      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'mr-bundle',
          itemCount: items.length,
          sections: didError ? undefined : data.sections,
          didError,
        },
      });

      if (didError && note) note.textContent = data.description || data.message || 'Could not add the bundle.';
    } catch (error) {
      deferred.reject(error);
      if (note) note.textContent = 'Could not add the bundle. Please try again.';
    } finally {
      button.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('mr-bundle')) {
  customElements.define('mr-bundle', MrBundle);
}
